var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "start-free" } },
    [
      _c("div", { staticClass: "row margin-bottom-4xl text-center" }, [
        _c("div", { staticClass: "column-12" }, [
          _c(
            "h2",
            {
              staticClass: "text-uppercase size-md with-anchor",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
                color: "var(--fa-md-gravy)",
              },
            },
            [
              _c("anchor-link", {
                attrs: {
                  anchor: "#start-free",
                  "link-color": "gravy",
                  "anchor-name": "Start for Free",
                },
              }),
              _vm._v("\n        No Reservations Required\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _c("h1", { staticClass: "h2 margin-y-md" }, [
            _vm._v("1 line of code… 1 million+ icons."),
          ]),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "line-length-xl margin-auto" },
            [
              _vm._v(
                "\n        No need to download, install, or manage files. Our Kits CDN does it all with a single line of code. With Font Awesome Free, you get easy access to\n        over " +
                  _vm._s(_vm.freeIconsRounded) +
                  " icons.\n        "
              ),
              _c(
                "site-link",
                {
                  attrs: { to: { name: "plans" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("upgrade_link_click", {
                        context: "home_view",
                      })
                    },
                  },
                },
                [_vm._v("Upgrade to a Pro plan")]
              ),
              _vm._v("\n        for even more.\n      "),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "margin-bottom-4xl tablet:margin-bottom-5xl laptop:margin-bottom-4xl",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "row align-middle align-center message margin-bottom-0 tablet:padding-y-3xl",
              staticStyle: {
                "--message-background": "var(--white)",
                "--link-color": "var(--fa-dk-gravy)",
                "--link-hover-color": "var(--fa-blue)",
              },
            },
            [
              _vm._m(0),
              _vm._v(" "),
              _c("start-form", {
                staticClass: "column-12 laptop:column-9 text-left",
                attrs: { "has-arrived-from-figma": false },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "column-12 laptop:column-3 margin-bottom-2xl laptop:margin-bottom-0 padding-0",
      },
      [
        _c("img", {
          staticClass: "margin-auto",
          attrs: {
            src: "https://img.fortawesome.com/1ce05b4b/start-illustration-homepage.svg",
            alt: "Rocket icon blasting off with a sun in the background",
          },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }